import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ChoiceInputItem} from '../../models/form-elements.model';

@Component({
  selector: 'app-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioComponent),
      multi: true
    }
  ]
})
export class InputRadioComponent implements OnInit, ControlValueAccessor {

  // Required
  @Input() label: string;
  @Input() labelExtraInfo?: string;
  @Input() name: string;
  @Input() id: string;
  @Input() choices: ChoiceInputItem[];

  // Conditional / Optional
  @Input() formSubmitted?: boolean;
  @Input() helpLink: string;
  @Input() cols?: number;

  // Default
  @Input() showLabel = true;
  @Input() showErrors = true;
  @Input() showOptional = true;
  @Input() showDisabledValue = false;
  @Input() isRequired = false;
  @Input() isReadOnly = false;
  @Input() isGrey = true;
  @Input() hasBorder = true;
  @Input() theme: 'light' | 'dark' = 'light';
  @Input() style: 'default' | 'bordered' = 'bordered';

  @Output() selectedItem = new EventEmitter<any>();
  @Output() onHelpClick = new EventEmitter<any>();

  public valueSrc: string;
  hasError: 'null' | 'length' | '';

  set value(val: any) {
    if (val !== null && this.valueSrc !== val) {
      this.valueSrc = val;
      this.selectedItem.emit(this.valueSrc);
      this.onChange(val);
      this.onTouch();
    }
  }

  get value(): any {
    return this.valueSrc;
  }

  constructor() {
  }


  ngOnInit() {
  }

  writeValue(value: string) {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: (value: string) => void) {
    // Required by the ControlValueAccessor interface. Informs Angular of value changes
    // Save the function as a property to call later.
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    // Required by the ControlValueAccessor interface. Informs Angular when input is touched.
    // Save the function as a property to call later.
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isReadOnly = isDisabled;
  }

  onChange(value?: string) {
  }

  onTouch() {
  }

}
